type ExtractParams<T extends string> =
  T extends `${string}{${infer Param}}${infer Rest}`
    ? Param | ExtractParams<Rest>
    : never;

function buildUrl<
  T extends string,
  P extends Record<ExtractParams<T>, string>,
>(url: T, params: P): string {
  return (Object.keys(params) as (keyof P)[]).reduce<string>(
    (acc, key) => acc.replaceAll(`{${String(key)}}`, params[key]),
    url,
  );
}

export { buildUrl, type ExtractParams };
